$shm_projects_goal_thinking $mol_page
	entries /
	title \Размышления
	tools /
		<= Close $mol_button_minor
			sub /
				<= Close_icon $mol_icon_close
			click? <=> close? null
	body /
		<= Status $mol_paragraph
			title <= status \
		<= Thinking_box $mol_view
			sub /
				<= Parts $mol_view
					sub <= part_rows /
	Part* $mol_card
		sub /
			<= Part_title* $mol_paragraph
				title <= part_title* \
				style *
					color <= part_title_color* \
			<= Part_text* $shm_agent_message_text
				text <= part_text* \
